import { ArrowLeftOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Checkbox, Form, Input, Layout, Select, Skeleton } from "antd";
import { Location, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { useAuth } from "../../../../Hooks/useAuth";
import { FinancialLinesService } from "../../../services/financialLines";
import { AllSectors } from "../../../../Utils/AllSectors";
import { AllCompanySizes } from "../../../../Utils/AllCompaniesSizes";
import { AllStates } from "../../../../Utils/AllStates";
import CardTitleCustom from "../../../components/card/title";
import { useToast } from '../../../../antd/hooks/toast';

export interface IFormItemsRefundable {
    email_usuario: string
    banco: string
    titulo_da_linha: string
    resumo: string
    o_que_pode_ser_financiado: string
    taxa_juros: string
    prazo_carencia: string
    prazo_total: string
    banco_de_fomento: string
    abrangencia: string
    porte_da_empresa: number[]
    setores: number[]
    link_saiba_mais: string
    ativar_linha: string
    Additional_information: string
}

export interface IFormItemsRefundablePut {
    id: string
    title: string
    summary: string
    bankName: string
    coverage: string
    totalTerm: string
    userEmail: string
    gracePeriods: string
    canBeFinanced: string
    interestRates: string
    linkLearnMore: string
    participationBank: string
    additionalInformation: string
    companySize: number[],
    sectors: number[],
    isVisible: string | boolean
}

export interface ILocationFinancialLines extends Location {
    id?: string
}

export default function RegisterRefundable() {
    const toast = useToast();
    const [form] = Form.useForm();
    const { state } = useLocation()
    const authData = useAuth()
    const navigate = useNavigate()

    const [loading, setLoading] = useState<boolean>(false)
    const [loadingSubmit, setLoadingSubmit] = useState<boolean>(false)

    const getRefundable = async () => {
        try {
            setLoading(true)

            const { data } = await FinancialLinesService.getRefundable(state.id)
            const { financingLines } = data;
            var coverage = financingLines.coverage.split(",")
            const companySizes = data.companySize.split(",").map((companySize: string) => {
                const foundCompanySize = AllCompanySizes.find(item => item.value === Number(companySize));
                return foundCompanySize ? foundCompanySize.value : null;
            });
            const sectors = data.sectors.split(",").map((sector: string) => {
                const foundSector = AllSectors.find(item => item.value === Number(sector));
                return foundSector ? foundSector.value : null;
            });

            form.setFields([
                { name: 'banco', value: financingLines.bankName },
                { name: 'titulo_da_linha', value: financingLines.title },
                { name: 'resumo', value: data.summary },
                { name: 'o_que_pode_ser_financiado', value: data.canBeFinanced },
                { name: 'taxa_juros', value: data.interestRates },
                { name: 'prazo_carencia', value: data.gracePeriods },
                { name: 'prazo_total', value: data.totalTerm },
                { name: 'banco_de_fomento', value: data.participationBank },
                { name: 'abrangencia', value: coverage },
                { name: 'porte_da_empresa', value: companySizes },
                { name: 'setores', value: sectors },
                { name: 'link_saiba_mais', value: financingLines.linkLearnMore },
            ])

        } catch (err) {

        } finally {
            setLoading(false)
        }
    }
    const handleChange = (value: any) => {
        if (value.includes('AllStates')) {
            value.splice(0, value.length - 1);
        }
        
    };

    const handleSubmit = async (values: IFormItemsRefundable) => {
        let coverage = "";
        if (Array.isArray(values.abrangencia)) {
            values.abrangencia.forEach((cover, index) => {
                if (index != values.abrangencia.length - 1) {
                    coverage += cover + ","
                } else {
                    coverage += cover;
                }
            }
            );
        } else {
            coverage = values.abrangencia;
        }
        setLoadingSubmit(true)

        

        if (state) {
            try {
                // CASO ATUALIZE
                var result = await FinancialLinesService.putRefundable({
                    additionalInformation: '',
                    bankName: values.banco,
                    canBeFinanced: values.o_que_pode_ser_financiado,
                    coverage: coverage,
                    gracePeriods: values.prazo_carencia,
                    id: state.id,
                    interestRates: values.taxa_juros,
                    isVisible: values.ativar_linha,
                    linkLearnMore: values.link_saiba_mais,
                    participationBank: values.banco_de_fomento,
                    summary: values.resumo,
                    title: values.titulo_da_linha,
                    totalTerm: values.prazo_total,
                    userEmail: authData.userEmail,
                    companySize: values.porte_da_empresa,
                    sectors: values.setores
                })
                if (result.status == 200) {
                    navigate('/finance/financialLines');
                    toast.success({ message: 'Linha de financiamento editada!' })
                } else {
                    toast.error({ message: "Erro ao editar linha de financiamento" })
                    if (result.errors.length != 0) {
                        result.errors.forEach((error: string) => toast.error({ message: error }))
                    }
                }
            } catch (err) {
                toast.error({ message: "Erro interno" })
            }
        } else {
            // CASO CRIE NOVO
            try {

                const data: IFormItemsRefundable = {
                    ...values,
                    email_usuario: authData.userEmail
                }
                data.abrangencia = coverage;

                var result = await FinancialLinesService.postRefundable(data)
                if (result.statusCode == 200) {
                    navigate('/finance/financialLines');
                    toast.success({ message: 'Linha de financiamento cadastrada!' })
                } else {
                    toast.error({ message: 'Erro ao cadastrar linha de financiamento' });
                    if (result.errors.length != 0) {
                        result.errors.forEach((error: string) => toast.error({ message: error }))
                    }
                }
            } catch (err) {
                toast.error({ message: "Erro interno" })
            }
        }
        setLoadingSubmit(false)
    }

    useEffect(() => {
        // CASO ENTRE COM UM JÁ CADASTRADO PARA EDITAR
        if (state) {
            getRefundable()
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const customizeRequiredMark = (label: React.ReactNode, { required }: { required: boolean }) => (
        <>
            {label}
            {required && <span style={{ color: "red" }}>*</span>}
        </>
    );
    const redirect = () => {
        navigate(`/finance/financialLines`)
    }

    return (
        <Layout style={{
            background: 'white',
            padding: '30px',
            marginTop: '16px',
            borderRadius: '15px'
        }}>
            <div>
                <Button
                onClick={() => redirect()}
                    style={{
                        width: "7%",
                        height: "40px",
                        backgroundColor: "white",
                        color: "#0000A4",
                        marginBottom: '20px',
                        border: '2px solid #0000A4'
                    }}
                >
                    <ArrowLeftOutlined />
                    Voltar
                </Button>
            </div>
            {CardTitleCustom({ text: `${state ? 'Editor' : 'Cadastro'} de Reembolsável` })}

            <div>
                {
                    loading
                        ? <Skeleton active style={{ margin: '25px 0px 0px 0px' }} />
                        :
                        <Form
                            layout="vertical"
                            requiredMark={customizeRequiredMark}
                            form={form}
                            onFinish={handleSubmit}
                            onSubmitCapture={(e) => e.preventDefault()}
                        >

                            <div style={{ display: 'grid', gridTemplate: '"a b" auto / 1fr 1fr', columnGap: '16px', margin: '16px 0px 0px 0px' }}>
                                <Form.Item
                                    label="Banco"
                                    name="banco"
                                    rules={[{ required: true, message: 'Por favor, insira seu banco de uso!' }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Título da Linha"
                                    name="titulo_da_linha"
                                    rules={[{ required: true, message: 'Por favor, insira o título da linha!' }]}
                                >
                                    <Input />
                                </Form.Item>
                                <Form.Item
                                    label="Resumo"
                                    name="resumo"
                                    rules={[{ required: true, message: 'Por favor, insira o resumo!' }]}
                                >
                                    <Input.TextArea />
                                </Form.Item>
                                <Form.Item
                                    label="O que pode ser financiado:"
                                    name="o_que_pode_ser_financiado"
                                    rules={[{ required: true, message: 'Por favor, insira o que pode ser financiado!' }]}
                                >
                                    <Input.TextArea />
                                </Form.Item>

                                <div style={{ display: 'grid', gridTemplate: '"a b" auto / 1fr 1fr', columnGap: '16px' }}>
                                    <Form.Item
                                        label="Taxa de Juros:"
                                        name="taxa_juros"
                                        rules={[{ required: true, message: 'Por favor, insira a taxa de juros!' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Prazo de carência:"
                                        name="prazo_carencia"
                                        rules={[{ required: true, message: 'Por favor, insira o prazo de carência!' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>

                                <div style={{ display: 'grid', gridTemplate: '"a b" auto / 1fr 1fr', columnGap: '16px' }}>
                                    <Form.Item
                                        label="Prazo Total:"
                                        name="prazo_total"
                                        rules={[{ required: true, message: 'Por favor, insira o prazo total!' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                    <Form.Item
                                        label="Participação do banco de fomento:"
                                        name="banco_de_fomento"
                                        rules={[{ required: true, message: 'Por favor, insira o banco de fomento!' }]}
                                    >
                                        <Input />
                                    </Form.Item>
                                </div>

                            </div>

                            <div style={{ display: 'grid', gridTemplate: '"a b c" auto / 1fr 1fr 1fr', columnGap: '16px' }}>
                                <Form.Item
                                    label="Abrangência"
                                    name="abrangencia"
                                    rules={[{ required: true, message: 'Por favor, insira abrangência!' }]}
                                >
                                    <Select
                                        mode="multiple"
                                        style={{ width: '100%' }}
                                        placeholder="Please select"
                                        defaultValue={[]}
                                        options={AllStates}
                                        onChange={handleChange}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Porte da empresa:"
                                    name="porte_da_empresa"
                                    rules={[{ required: true, message: 'Por favor, insira o porte da sua empresa!' }]}
                                >
                                    <Select mode="multiple" options={AllCompanySizes}></Select>
                                </Form.Item>
                                <Form.Item
                                    label="Setores:"
                                    name="setores"
                                    rules={[{ required: true, message: 'Por favor, insira os setores!' }]}
                                >
                                    <Select mode="multiple" options={AllSectors}></Select>
                                </Form.Item>
                            </div>

                            <Form.Item
                                label="Link para o ”Saiba mais”:"
                                name="link_saiba_mais"
                                rules={[{ required: true, message: 'Por favor, insira o link para saber mais do seu projeto!' }]}
                            >
                                <Input />
                            </Form.Item>

                            <div style={{ width: '100%' }}>
                                <Form.Item
                                    label="Ativar linha"
                                    name="ativar_linha"
                                    layout="horizontal"
                                    valuePropName="checked"
                                >
                                    <Checkbox />
                                </Form.Item>
                            </div>

                            <Button htmlType="submit" loading={loadingSubmit} style={{ width: '100%', height: '40px', backgroundColor: '#0000A4', color: 'white' }}>
                                {
                                    state
                                        ? <>Atualizar linha</>
                                        : <> <PlusCircleOutlined />&nbsp;Adicionar Linha </>
                                }
                            </Button>

                        </Form>
                }
            </div>
        </Layout>
    )
}